// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__K9AUr","cell":"ColumnAccessor_cell__2uPsX","firstCellAccent":"ColumnAccessor_firstCellAccent__1GOaC"};